module.exports = __webpack_public_path__ + "images/e345779a8e43f08a06d4d57a5044961b-logo_white.png";